import { ScrollableList } from '@ps/isp-web-component-library';
import type { EventType } from '@ps/isp-web-services-types';
import type { FC } from 'react';
import { useSelector } from 'react-redux';

import { Icon } from '@swf/sports/components';
import { getEventTypeIcon } from '@swf/sports/utils/getEventTypeIcon';

import { useSportsMenuWidget } from '../../../../../model';

import styles from './SportsPills.scss';

interface Props {
  selectedEventTypeId: EventType;
}

const SportsPills: FC<Props> = ({ selectedEventTypeId }) => {
  const { widgetDispatch, widgetSelect } = useSportsMenuWidget();
  const { uniqueEventTypes } = useSelector(widgetSelect.searchResults);

  return (
    <ScrollableList>
      {uniqueEventTypes.map(({ eventTypeId, text: eventTypeName }) => (
        <ScrollableList.Tab
          key={eventTypeId}
          onClick={() => widgetDispatch.setSelectedEventType(eventTypeId)}
          active={selectedEventTypeId === eventTypeId}
        >
          <span key={eventTypeId} className={styles.textWrapper}>
            <Icon name={getEventTypeIcon(eventTypeId)} size="xl" className={styles.icon} />
            {eventTypeName}
          </span>
        </ScrollableList.Tab>
      ))}
    </ScrollableList>
  );
};

export default SportsPills;
